import { isNil } from 'lodash';
import React from 'react';
import { View } from '@shared/components/View';
import { MBLoadingIndicator } from '@shared/components/loading';
import { MBCardDetails } from '@shared/scenes/cards/details/containers';
import { MBCardDetailsOptionsButton } from '@shared/scenes/cards/details/containers/optionsButton';
import { useChannel } from '@shared/util/hooks';

interface Props {
  channelId: number;
  cardId: string;
  templateSlug?: string;
}

export function CardDetails({ channelId, cardId, templateSlug }: Props) {
  const channel = useChannel({ channelId });
  if (isNil(channel)) {
    return <MBLoadingIndicator fill center />;
  }
  return (
    <View fill>
      <MBCardDetailsOptionsButton
        channelSlug={channel.slug}
        cardId={cardId}
        style={{ alignSelf: 'flex-end' }}
        hiddenCardOptions={[
          'edit',
          'duplicate',
          'share',
          'cardHistory',
          'print',
          'selectMultiple',
          'delete',
          'bulkUpdate',
        ]}
      />
      <MBCardDetails channelSlug={channel.slug} cardId={cardId} templateSlug={templateSlug} />
    </View>
  );
}
